import { getAddressLine } from '@app/utils/getAddressLine';
import { isDefined } from '@app/utils/is';
import { isEmpty } from '@app/utils/isEmpty';
import { Addresses } from '@typings';
import { useTranslation } from 'react-i18next';

interface Props {
  address: Addresses.Basic | undefined;
  isLoading?: boolean;
}

export const InvoiceShippingAddress = ({ address, isLoading }: Props) => {
  const { t } = useTranslation(['shipping', 'common']);

  if (isLoading || !isDefined(address)) {
    return null;
  }

  const addressLines = [
    getAddressLine(address.address1, address.address2),
    `${address.zipCode} ${address.city}`,
    `${address.stateName ?? address.state ?? ''} ${address.countryName}`,
  ]
    .filter(line => !isEmpty(line.trim()))
    .map(line => <div key={line}>{line}</div>);

  return (
    <div className="mt-8 border-t border-neutral-90 pt-8">
      <section className="box">
        <h3 className="mb-5 heading-3">{t('shipping:shipping_address_one')}</h3>
        <div data-sentry-mask className="box flex w-[min-content] min-w-64 flex-col bg-neutral-96">
          {/* check if address.company is string should be removed after fixing https://centracommerce.atlassian.net/browse/SBFT-3172 */}
          {typeof address.company === 'string' && !isEmpty(address.company) && (
            <span className="mb-5 truncate heading-3">{address.company}</span>
          )}
          <span className="mb-1 body-6">{t('common:address')}</span>
          <span className="body-5">{addressLines}</span>
        </div>
      </section>
    </div>
  );
};
